import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import React, { useEffect, useState } from "react";

const UI2ColumnChart = (props) => {
  const { dataList, title, type } = props;
  const [seriesData, setSeriesData] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);

  useEffect(() => {
    // console.log("dataList >>", dataList);

    if (dataList !== undefined && dataList.length > 0) {
      const getDateKey = (item) =>
        type === "DAY" ? item.psDate : item.yearMonth;

      const uniqueEngIds = [...new Set(dataList.map((item) => item.engId))];
      const uniqueDates = [...new Set(dataList.map(getDateKey))];

      const series = uniqueEngIds.map((engId) => {
        const data = dataList
          .filter((item) => item.engId === engId)
          .sort((a, b) => getDateKey(a).localeCompare(getDateKey(b)))
          .map((item) => item.sumAmt);

        const method = dataList
          .filter((item) => item.engId === engId)
          .sort((a, b) => getDateKey(a).localeCompare(getDateKey(b)))
          .map((item) => item.method);

          const engUnit = dataList
          .filter((item) => item.engId === engId)
          .sort((a, b) => getDateKey(a).localeCompare(getDateKey(b)))
          .map((item) => item.engUnit);

          const engName = dataList
          .filter((item) => item.engId === engId)
          .sort((a, b) => getDateKey(a).localeCompare(getDateKey(b)))
          .map((item) => item.engName);

        return {
          name: engId,
          data: data,
          method: method,
          engName : engName,
          engUnit : engUnit
          
        };
      });

      // console.log("series >>>", series);

      const categories = uniqueDates.sort((a, b) => a.localeCompare(b));

      setSeriesData(series);
      setCategoriesData(categories);
    } else {
      setSeriesData([]);
      setCategoriesData([]);
    }
  }, [dataList, type]);

  const optionData = {
    chart: {
      backgroundColor: "rgba(255,255,255, 0.1)",
      type: "column",
    },
    title: {
      text: title,
      style: { color: "white" },
    },
    xAxis: {
      categories: categoriesData,
      lineColor: "#555",
      labels: {
        style: {
          color: "rgba(255,255,255,0.8)",
        },
        formatter: function () {
          let outputValue = "";
          if (this.value.length === 6) {
            outputValue = `${this.value.substring(2, 4)}.${this.value.substring(
              4,
              6
            )}`;
          } else if (this.value.length === 8) {
            outputValue = `${this.value.substring(6)}일`;
          } else {
            outputValue = this.value;
          }

          return outputValue;
        },
      },
    },
    yAxis: {
      labels: {
        style: {
          color: "rgba(255,255,255,0.8)",
        },
      },
      lineWidth: 1,
      lineColor: "#555",
      gridLineColor: "#555",
    },
    tooltip: {
      crosshairs: true,
      shared: false,
      formatter: function () {
        let header = "";
        // x축 레이블의 포매팅 로직을 여기에 적용
        if (this.x.length === 6) {
          header = `${this.x.substring(2, 4)}.${this.x.substring(4, 6)}`;
        } else if (this.x.length === 8) {
          header = `${this.x.substring(4, 6)}월 ${this.x.substring(6)}일`;
        } else {
          header = this.x;
        }

        let unit = "";
        let name = "";
        const methodValue = this.series.userOptions.method[this.point.index];
        let methodName = "";
        console.log("methodValue >>", methodValue);
        if (methodValue === "cons") {
          methodName = "사용";
        } else if (methodValue === "prod") {
          methodName = "공급";
        } else {
          methodName = methodValue;
        }

        unit = this.series.userOptions.engUnit[this.point.index];
        
        name = this.series.userOptions.engName[this.point.index];
        
       

        return (
          '<span style="font-size: 12px">' +
          header +
          "</span><br/>" +
          '<span style="color:' +
          this.color +
          '">●</span> ' +
          name +
          "(" +
          methodName +
          "): <b>" +
          Highcharts.numberFormat(this.y, 0, ".", ",") +
          " " +
          unit +
          "</b><br/>"
        );
      },
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        pointWidth: 35,
        groupPadding: 0.5,
      },
    },
    plotOptions: {
      column: {
        // pointPadding: 0.2,
        minPointLength: 3,
        pointPadding: categoriesData.length > 25 ? 0.1 : 0.2,
        borderWidth: 0,
        pointWidth: categoriesData.length > 25 ? 15 : 35,
        groupPadding: 0.5,
      },
    },
    legend: {
      // itemStyle: {
      //   color: "rgba(255,255,255,0.9)",
      //   fontWeight: "400",
      // },
      enabled: false
    },
    series: seriesData,
  };

  return <HighchartsReact highcharts={Highcharts} options={optionData} />;
};

export default UI2ColumnChart;
